<template>
  <v-layout justify-center>
    <v-dialog
      :value="show"
      content-class="modal-base"
      :max-width="maxWidth"
      :persistent="persistent"
       @input="$emit('closePopUp')"
    >
      <v-card>
        <!-- Titulo -->
        <v-toolbar :color="colorHeader" dark text-break>
          <F2gIcon
            v-if="iconValue"
            class="mr-2"
            :value="iconValue"
            :height="24"
            :width="24"
            stroke="white"
            :strokeWidth="3"
          />
          <v-toolbar-title class="w-full" style="overflow-wrap: anywhere">
            <v-layout justify-space-between align-center>
              <span class="truncate">{{ title }}</span>
              <div
                @click="
                  $emit('close');
                  $emit('eventCancel');
                "
              >
                <F2gIcon
                  v-if="showClose"
                  class="cursor-pointer"
                  value="close"
                  stroke="white"
                  :strokeWidth="4"
                  :height="35"
                  :width="35"
                />
              </div>
            </v-layout>
          </v-toolbar-title>
        </v-toolbar>
        <!-- Cuerpo -->
        <v-card-text :style="`padding: ${!padding ? 0 : '16px 24px'}`">
          <v-layout column>
            <slot name="body">
              <span class="text" v-if="infoText">{{ infoText }}</span>
            </slot>
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="showActions" class="pa-3">
          <slot name="buttons">
            <v-spacer></v-spacer>
            <v-btn
              :color="colorButtonCancel"
              text
              class="button-rounded"
              @click="$emit('eventCancel')"
              >{{ buttonCancel }}</v-btn
            >
            <v-btn
              :color="colorButtonAccept"
              text
              class="button-rounded"
              @click="$emit('eventConfirm')"
              >{{ buttonAccept }}</v-btn
            >
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "PopUp-modal-base",
  props: {
    title: { required: true, type: String },
    iconValue: { required: false, type: String },
    infoText: { required: false, type: String },
    buttonCancel: { required: false, type: String, default: "Cancelar" },
    buttonAccept: { required: false, type: String, default: "Aceptar" },
    show: { required: true, type: Boolean },
    maxWidth: { required: false, type: String, default: "400" },
    showClose: { required: false, type: Boolean, default: false },
    showActions: {
      required: false,
      type: Boolean,
      default: true,
    },
    padding: {
      required: false,
      type: Boolean,
      default: true,
    },
    colorHeader: { required: false, type: String, default: "primary" },
    colorButtonAccept: { required: false, type: String, default: "primary" },
    colorButtonCancel: { required: false, type: String, default: "error" },
    persistent: { required: false, type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
@import "@/flit2go-web-core/shared-styles/animations/writing.scss";
@include writing();

.modal-base {
  svg {
    height: 28px;
    width: 28px;
  }

  use.onion-icon {
    stroke: white;
    fill: white;
  }

  use.onion-icon {
    fill-opacity: 0;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    stroke-width: 1;

    $step-time: 0;
    @for $i from 1 through 5 {
      &:nth-child(#{$i}) {
        -webkit-animation: writing 2s ease-in forwards #{$step-time}s;
        animation: writing 2s ease-in forwards #{$step-time}s;
        $step-time: $step-time + 0.4;
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .v-textarea.v-text-field--enclosed textarea {
    margin-top: 0px;
  }
}
</style>
